import React from 'react'
import { Button as CmButton } from '../ui/Button'

// Legacy colour classes passed by older screens → the matching ChipMonk variant.
const variantFromClass = (cls = '') => {
  if (/\b(bg-red|bg-rose)/.test(cls)) return 'danger'
  if (/\b(bg-gray|bg-slate|bg-white)/.test(cls)) return 'secondary'
  return 'primary'
}

/**
 * Kept for older screens: <Button text="Save" onClick={...} className="bg-green-500 ..." />.
 * Renders the ChipMonk button; layout classes in `custom`/`className` still apply.
 */
const Button = ({ onClick, disabled, text, type = 'button', custom, className, children, variant, size = 'sm', icon }) => {
  const layout = `${className || ''} ${custom || ''}`
    .split(/\s+/)
    .filter((c) => c && !/^(hover:)?(bg|text)-/.test(c))
    .join(' ')
  return (
    <CmButton
      type={type}
      onClick={onClick}
      disabled={disabled}
      variant={variant || variantFromClass(className)}
      size={size}
      icon={icon}
      className={layout}
    >
      {text ?? children}
    </CmButton>
  )
}

export default Button
